import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';

import { HeadingEffects } from './heading.effects';
import { reducer } from './heading.reducer';

@NgModule({
  imports: [
    CommonModule,
    StoreModule.forFeature('heading', reducer),
    EffectsModule.forFeature([HeadingEffects]),
  ],
  providers: [HeadingEffects],
})
export class HeadingStoreModule {}
